import { withoutEmptyProps } from '..';
const serialize = (params = {}) => {
  const cleanParams = withoutEmptyProps(params, true);
  return Object.keys(cleanParams).length > 0 ? `?${new URLSearchParams(cleanParams).toString()}` : '';
};
export default serialize;